import * as types from './actionTypes';

export const setIncreament = () => {
    return {
        type: types.COUNTER,
    };
};
